// extracted by mini-css-extract-plugin
export default {"compareSwitch":"OmNsFaQ8","controlElement":"RxmxA4FW"};